/* Generated by scripts/build_theme.py from the inline <script> blocks of

   index.html, shop.html, boxes/premium.html, our-story.html, contact.html.

   Order is preserved and duplicates dropped. Every block guards on its own

   selectors, so it is inert on pages that do not contain its markup.

   jQuery, GSAP, ScrollTrigger, SplitText, Swiper and Lenis must load first. */

/* ---- block 0 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".nav_master_wrap").forEach((element) => {
    if (element.dataset.scriptInitialized) return;
    element.dataset.scriptInitialized = "true";
    
    $('.nav_mega_menu_txt').on('click', function() {
      $('.nav_list_item.is-menu').click();
    });
  });
});
  } catch (e) {
    console.warn('prototype.js block 0:', e && e.message);
  }
})();

/* ---- block 1 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", () => {
  function trapTab() {
    const menuList = document.querySelector(".nav_mega_menu_list");
    const navBtnWrap = document.querySelector("#menu-toggle");

    if (!menuList || !navBtnWrap) return;

    const focusableSelectors = 'a[href], button, textarea, input[type="text"], [tabindex]:not([tabindex="-1"])';
    const focusableItems = menuList.querySelectorAll(focusableSelectors);
    const lastItem = focusableItems[focusableItems.length - 1];

    lastItem.addEventListener("keydown", (e) => {
      if (e.key === "Tab" && !e.shiftKey) {
        e.preventDefault();
        navBtnWrap.focus();
      }
    });
  }
  trapTab();
});
  } catch (e) {
    console.warn('prototype.js block 1:', e && e.message);
  }
})();

/* ---- block 2 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", (event) => {

  let navTl = gsap.timeline({
    defaults: { ease: "power2.out" }
  });

  navTl.to(".nav_master_wrap", { opacity: 1, duration: 1 });

});
  } catch (e) {
    console.warn('prototype.js block 2:', e && e.message);
  }
})();

/* ---- block 3 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".testimonial_wrap").forEach((element) => {
    if (element.dataset.scriptInitialized) return;
    element.dataset.scriptInitialized = "true";
    
    $(".testimonial_slider_component").each(function (index) {
      let sliderComponent = $(this);
      let paginationElement = sliderComponent.siblings(".swiper-pagination");
      let nextButton = sliderComponent.find(".swiper-next");
      let prevButton = sliderComponent.find(".swiper-prev");
      let dragWrapper = sliderComponent.find(".swiper-drag-wrapper");
      
      let loopMode = sliderComponent.attr("loop-mode") === "true";
      let sliderDuration = 300;
      if (sliderComponent.attr("slider-duration") !== undefined) {
        sliderDuration = +sliderComponent.attr("slider-duration");
      }
      
      const swiper = new Swiper(sliderComponent.find(".swiper")[0], {
        speed: sliderDuration,
        loop: loopMode,
        autoHeight: false,
        centeredSlides: loopMode,
        followFinger: true,
        freeMode: false,
        slideToClickedSlide: false,
        
        autoplay: {
 			  disableOnInteraction: false
				},
        
        // Enable fade effect
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        
        // Your existing settings
        slidesPerView: 1, // Important: Must be 1 for fade effect
        spaceBetween: 0,  // Important: Should be 0 for fade effect
        rewind: false,
        mousewheel: {
          forceToAxis: true
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        pagination: {
          el: paginationElement[0],
          clickable: true,
        },
        navigation: {
          nextEl: nextButton[0],
          prevEl: prevButton[0],
          disabledClass: "is-disabled"
        },
        scrollbar: {
          el: dragWrapper[0],
          draggable: true,
          dragClass: "swiper-drag",
          snapOnRelease: true
        },
        slideActiveClass: "is-active",
        slideDuplicateActiveClass: "is-active"
      });
    });
  });
});
  } catch (e) {
    console.warn('prototype.js block 3:', e && e.message);
  }
})();

/* ---- block 4 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", function() {
 document.querySelectorAll(".faq_cms_wrap").forEach((cmsWrap, listIndex) => {
 if (cmsWrap.dataset.scriptInitialized) return;
 cmsWrap.dataset.scriptInitialized = "true";

 const closePrevious = cmsWrap.getAttribute("data-close-previous") !== "false";
 const closeOnSecondClick = cmsWrap.getAttribute("data-close-on-second-click") !== "false";
 const openOnHover = cmsWrap.getAttribute("data-open-on-hover") === "true";
 const openByDefault = cmsWrap.getAttribute("data-open-by-default") !== null && !isNaN(+cmsWrap.getAttribute("data-open-by-default")) ? +cmsWrap.getAttribute("data-open-by-default") : false;

 let previousIndex = null, closeFunctions = [];

 cmsWrap.querySelectorAll(".faq_component").forEach((thisCard, cardIndex) => {
 const button = thisCard.querySelector(".faq_toggle_button");
 const content = thisCard.querySelector(".faq_content_wrap");
 const icon = thisCard.querySelector(".faq_toggle_icon");

 if (!button || !content || !icon) return console.warn("Missing elements:", thisCard);

 button.setAttribute("aria-expanded", "false");
 button.setAttribute("id", "faq_button_" + listIndex + "_" + cardIndex);
 content.setAttribute("id", "faq_content_" + listIndex + "_" + cardIndex);
 button.setAttribute("aria-controls", content.id);
 content.setAttribute("aria-labelledby", button.id);
 content.style.display = "none";

 const refresh = () => { tl.invalidate(); if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh(); };
 const tl = gsap.timeline({ paused: true, defaults: { duration: 0.3, ease: "power1.inOut" }, onComplete: refresh, onReverseComplete: refresh });
 tl.set(content, { display: "block" });
 tl.fromTo(content, { height: 0 }, { height: "auto" });
 tl.fromTo(icon, { rotate: 0 }, { rotate: -45 }, "<");

 const closeAccordion = () => thisCard.classList.contains("is-opened") && (thisCard.classList.remove("is-opened"), tl.reverse(), button.setAttribute("aria-expanded", "false"));
 closeFunctions[cardIndex] = closeAccordion;

 const openAccordion = (instant = false) => {
 if (closePrevious && previousIndex !== null && previousIndex !== cardIndex) closeFunctions[previousIndex]?.();
 previousIndex = cardIndex;
				button.setAttribute("aria-expanded", "true")
 thisCard.classList.add("is-opened");
 instant ? tl.progress(1) : tl.play();
 };
 if (openByDefault === cardIndex) openAccordion(true);

 button.addEventListener("click", () => thisCard.classList.contains("is-opened") && closeOnSecondClick ? (closeAccordion(), previousIndex = null) : openAccordion());
 if (openOnHover) button.addEventListener("mouseenter", () => openAccordion());
 });
 });
});
  } catch (e) {
    console.warn('prototype.js block 4:', e && e.message);
  }
})();

/* ---- block 5 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".ugc_wrap").forEach((element) => {
    if (element.dataset.scriptInitialized) return;
    element.dataset.scriptInitialized = "true";
    
    $(".ugc_slider_component").each(function (index) {
      const $component = $(this);
      const componentElement = this;
      let isInitialized = false;
      let swiperReady = false;
      
      let loopMode = false;
      if ($(this).attr("loop-mode") === "true") {
        loopMode = true;
      }
      
      let sliderDuration = 300;
      if ($(this).attr("slider-duration") !== undefined) {
        sliderDuration = +$(this).attr("slider-duration");
      }

      let isAnyVideoUnmuted = false;

      const pauseAllVideos = () => {
        $component.find('.swiper-slide.is-ugc video').each(function() {
          this.pause();
        });
      };

      const muteAllVideos = (pauseActiveVideo = false) => {
        $component.find('.swiper-slide.is-ugc video').each(function(index) {
          this.muted = true;
          // Only pause non-active videos OR if specifically requested
          if (!$(this).closest('.swiper-slide').hasClass('is-active') || pauseActiveVideo) {
            this.pause();
          }
        });
        $component.find('.ugc_sound_icon.is-muted').show();
        $component.find('.ugc_sound_icon.is-unmuted').hide();
        isAnyVideoUnmuted = false;
      };

      const updateSoundUI = ($slide, isMuted) => {
        const $mutedIcon = $slide.find('.ugc_sound_icon.is-muted');
        const $unmutedIcon = $slide.find('.ugc_sound_icon.is-unmuted');
        
        if (isMuted) {
          $mutedIcon.show();
          $unmutedIcon.hide();
        } else {
          $mutedIcon.hide();
          $unmutedIcon.show();
        }
      };

      const playActiveVideo = () => {
        if (!isInitialized || !swiperReady) return;
        
        pauseAllVideos();
        
        const activeIndex = swiper.activeIndex;
        const $allSlides = $component.find('.swiper-slide.is-ugc');
        const $activeSlide = $allSlides.eq(activeIndex);
        
        $allSlides.removeClass('is-active');
        $activeSlide.addClass('is-active');
        
        const $video = $activeSlide.find('video');
        if ($video.length) {
          const video = $video[0];
          video.play().catch(() => {});
        }
      };

      const handleSlideClick = ($clickedSlide) => {
        const $video = $clickedSlide.find('video');
        if (!$video.length || !$clickedSlide.hasClass('is-active')) return;
        
        const video = $video[0];
        
        if (isAnyVideoUnmuted) {
          // Mute all videos but keep active video playing
          muteAllVideos(false);
        } else {
          // Pause all videos, then unmute and play only the active video
          muteAllVideos(true);
          video.muted = false;
          updateSoundUI($clickedSlide, false);
          isAnyVideoUnmuted = true;
          video.play().catch(() => {});
        }
      };

      const handleVideoOnSlideChange = (activeIndex) => {
        if (!isInitialized || !swiperReady) return;
        
        pauseAllVideos();
        
        $component.find('.swiper-slide.is-ugc').each(function(index) {
          const $slide = $(this);
          const video = $slide.find('video')[0];
          if (video && index !== activeIndex) {
            video.muted = true;
            video.pause(); // Ensure non-active videos are paused
            updateSoundUI($slide, true);
          }
        });
        
        if (componentElement.dataset.inViewport === 'true') {
          setTimeout(() => {
            const $newActiveSlide = $component.find('.swiper-slide.is-ugc.is-active');
            const $newVideo = $newActiveSlide.find('video');
            
            if ($newVideo.length) {
              const newVideo = $newVideo[0];
              
              if (isAnyVideoUnmuted) {
                newVideo.muted = false;
                updateSoundUI($newActiveSlide, false);
              }
              
              playActiveVideo();
            }
          }, sliderDuration + 50);
        }
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            componentElement.dataset.inViewport = 'true';
            if (isInitialized && swiperReady) {
              setTimeout(() => playActiveVideo(), 100);
            }
          } else {
            componentElement.dataset.inViewport = 'false';
            pauseAllVideos();
            if (isAnyVideoUnmuted) {
              muteAllVideos(true); // Pause everything when scrolling away
            }
          }
        });
      }, {
        root: null,
        rootMargin: '50px',
        threshold: 0.3
      });

      const swiper = new Swiper($(this).find(".swiper")[0], {
        speed: sliderDuration,
        loop: loopMode,
        slidesPerView: "auto", 
        spaceBetween: 20,
        watchSlidesProgress: true,
        resistance: false,
        normalizeSlideIndex: false,
        keyboard: false,
        navigation: {
          nextEl: null,
          prevEl: null
        },
        pagination: {
          el: $(this).find(".swiper-bullet-wrapper")[0],
          bulletActiveClass: "is-active",
          bulletClass: "swiper-bullet",
          bulletElement: "button",
          clickable: true
        },
        scrollbar: {
          el: $(this).find(".swiper-drag-wrapper")[0],
          draggable: true,
          dragClass: "swiper-drag",
          snapOnRelease: true
        },
        slideActiveClass: "is-active",
        slideDuplicateActiveClass: "is-active",
        on: {
          init: function() {
            swiperReady = true;
          }
        }
      });

      const nextButton = $(this).find(".swiper-next");
      const prevButton = $(this).find(".swiper-prev");

      const updateNavigationState = () => {
        const currentIndex = swiper.activeIndex;
        const totalSlides = swiper.slides.length;
        
        if (currentIndex === 0) {
          prevButton.addClass('is-disabled');
        } else {
          prevButton.removeClass('is-disabled');
        }
        
        if (currentIndex === totalSlides - 1) {
          nextButton.addClass('is-disabled');
        } else {
          nextButton.removeClass('is-disabled');
        }
      };

      const moveSlide = (direction) => {
        if (!swiper.slides) return;
        
        const currentIndex = swiper.activeIndex;
        const totalSlides = swiper.slides.length;
        let targetIndex;
        
        if (direction === 'prev') {
          targetIndex = Math.max(0, currentIndex - 1);
        } else {
          targetIndex = Math.min(totalSlides - 1, currentIndex + 1);
        }
        
        swiper.slideTo(targetIndex, sliderDuration, true);
        
        setTimeout(() => {
          swiper.slides.forEach((slide, index) => {
            if (index === targetIndex) {
              slide.classList.add('is-active');
            } else {
              slide.classList.remove('is-active');
            }
          });
          updateNavigationState();
          handleVideoOnSlideChange(targetIndex);
        }, 50);
      };

      const handleKeyNavigation = (e) => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          moveSlide(e.key === 'ArrowLeft' ? 'prev' : 'next');
        }
      };

      nextButton.on('click', () => {
        if (!nextButton.hasClass('is-disabled')) {
          moveSlide('next');
        }
      });

      prevButton.on('click', () => {
        if (!prevButton.hasClass('is-disabled')) {
          moveSlide('prev');
        }
      });

      document.addEventListener('keydown', handleKeyNavigation);

      swiper.on('slideChange', function() {
        const currentIndex = this.activeIndex;
        
        this.slides.forEach((slide, index) => {
          if (index === currentIndex) {
            slide.classList.add('is-active');
          } else {
            slide.classList.remove('is-active');
          }
        });
        
        updateNavigationState();
        handleVideoOnSlideChange(currentIndex);
      });

      swiper.on('paginationRender', function() {
        $component.find('.swiper-bullet').on('click', function() {
          setTimeout(() => {
            handleVideoOnSlideChange(swiper.activeIndex);
          }, sliderDuration + 50);
        });
      });

      $component.find('.swiper-slide.is-ugc').on('click', function(e) {
        e.stopPropagation();
        handleSlideClick($(this));
      });
      
      $component.find('.swiper-slide.is-ugc video').on('click', function(e) {
        e.stopPropagation();
        const $slide = $(this).closest('.swiper-slide.is-ugc');
        handleSlideClick($slide);
      });

      pauseAllVideos();
      muteAllVideos(true); // Initially pause and mute everything
      updateNavigationState();

      $component.find('.swiper-slide.is-ugc video').each(function() {
        this.preload = 'metadata';
        this.muted = true;
        this.playsInline = true;
        this.loop = true;
        this.pause();
      });

      isInitialized = true;
      observer.observe(componentElement);
      
      const checkInitialViewport = () => {
        if (!swiperReady) {
          setTimeout(checkInitialViewport, 50);
          return;
        }
        
        pauseAllVideos();
        
        const rect = componentElement.getBoundingClientRect();
        const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
        
        if (isInViewport) {
          componentElement.dataset.inViewport = 'true';
          
          setTimeout(() => {
            $component.find('.swiper-slide.is-ugc').removeClass('is-active');
            $component.find('.swiper-slide.is-ugc').first().addClass('is-active');
            swiper.slideTo(0, 0);
            playActiveVideo();
          }, 150);
        }
      };
      
      setTimeout(checkInitialViewport, 100);

      if (window.ugcSliderObservers) {
        window.ugcSliderObservers.push(observer);
      } else {
        window.ugcSliderObservers = [observer];
      }
    });
  });
});

window.cleanupUGCSliders = function() {
  if (window.ugcSliderObservers) {
    window.ugcSliderObservers.forEach(observer => observer.disconnect());
    window.ugcSliderObservers = [];
  }
};
  } catch (e) {
    console.warn('prototype.js block 5:', e && e.message);
  }
})();

/* ---- block 6 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".footer_wrap").forEach((element) => {
    if (element.dataset.scriptInitialized) return;
    element.dataset.scriptInitialized = "true";
    
    $(".socials_slider_component").each(function (index) {
      let sliderComponent = $(this);
      // Important: Now using standard Swiper pagination class
      let paginationElement = sliderComponent.siblings(".swiper-pagination");
      let nextButton = sliderComponent.find(".swiper-next");
      let prevButton = sliderComponent.find(".swiper-prev");
      let dragWrapper = sliderComponent.find(".swiper-drag-wrapper");
      
      let loopMode = sliderComponent.attr("loop-mode") === "true";
      let sliderDuration = 300;
      if (sliderComponent.attr("slider-duration") !== undefined) {
        sliderDuration = +sliderComponent.attr("slider-duration");
      }
      
      const swiper = new Swiper(sliderComponent.find(".swiper")[0], {
        speed: sliderDuration,
        loop: loopMode,
        autoHeight: false,
        centeredSlides: loopMode,
        followFinger: true,
        freeMode: false,
        slideToClickedSlide: false,
        slidesPerView: "auto",
        spaceBetween: 20,
        rewind: false,
        mousewheel: {
          forceToAxis: true
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        breakpoints: {
          480: {
            slidesPerView: "auto",
            spaceBetween: 20
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 20
          },
          992: {
            slidesPerView: "auto",
            spaceBetween: 20
          }
        },
        pagination: {
          el: paginationElement[0],
          clickable: true,
          // Using Swiper's default classes instead of custom ones
          // This will use the default swiper-pagination-bullet and swiper-pagination-bullet-active classes
        },
        navigation: {
          nextEl: nextButton[0],
          prevEl: prevButton[0],
          disabledClass: "is-disabled"
        },
        scrollbar: {
          el: dragWrapper[0],
          draggable: true,
          dragClass: "swiper-drag",
          snapOnRelease: true
        },
        slideActiveClass: "is-active",
        slideDuplicateActiveClass: "is-active"
      });
    });
  });
});
  } catch (e) {
    console.warn('prototype.js block 6:', e && e.message);
  }
})();

/* ---- block 7 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", (event) => {
  
gsap.registerPlugin(ScrollTrigger);
  
gsap.set([".page_main"], { opacity: 1 });
});
  } catch (e) {
    console.warn('prototype.js block 7:', e && e.message);
  }
})();

/* ---- block 8 ---- */
(function () {
  try {
let lenis = new Lenis({
  lerp: 0.1,
  wheelMultiplier: 0.7,
  gestureOrientation: "vertical",
  normalizeWheel: false,
  smoothTouch: false,
});
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
$("[data-lenis-start]").on("click", function () {
  lenis.start();
});
$("[data-lenis-stop]").on("click", function () {
  lenis.stop();
});
$("[data-lenis-toggle]").on("click", function () {
  $(this).toggleClass("stop-scroll");
  if ($(this).hasClass("stop-scroll")) {
    lenis.stop();
  } else {
    lenis.start();
  }
});
  } catch (e) {
    console.warn('prototype.js block 8:', e && e.message);
  }
})();

/* ---- block 9 ---- */
(function () {
  try {
// MARQUEE POWER-UP
window.addEventListener("DOMContentLoaded", (event) => {
  // attribute value checker
  function attr(defaultVal, attrVal) {
    const defaultValType = typeof defaultVal;
    if (typeof attrVal !== "string" || attrVal.trim() === "") return defaultVal;
    if (attrVal === "true" && defaultValType === "boolean") return true;
    if (attrVal === "false" && defaultValType === "boolean") return false;
    if (isNaN(attrVal) && defaultValType === "string") return attrVal;
    if (!isNaN(attrVal) && defaultValType === "number") return +attrVal;
    return defaultVal;
  }
  // marquee component
  $("[tr-marquee-element='component']").each(function (index) {
    let componentEl = $(this),
      panelEl = componentEl.find("[tr-marquee-element='panel']"),
      triggerHoverEl = componentEl.find("[tr-marquee-element='triggerhover']"),
      triggerClickEl = componentEl.find("[tr-marquee-element='triggerclick']");
    let speedSetting = attr(100, componentEl.attr("tr-marquee-speed")),
      verticalSetting = attr(false, componentEl.attr("tr-marquee-vertical")),
      reverseSetting = attr(false, componentEl.attr("tr-marquee-reverse")),
      scrollDirectionSetting = attr(false, componentEl.attr("tr-marquee-scrolldirection")),
      scrollScrubSetting = attr(false, componentEl.attr("tr-marquee-scrollscrub")),
      moveDistanceSetting = -100,
      timeScaleSetting = 1,
      pausedStateSetting = false;
    if (reverseSetting) moveDistanceSetting = 100;
    let marqueeTimeline = gsap.timeline({ repeat: -1, onReverseComplete: () => marqueeTimeline.progress(1) });
    if (verticalSetting) {
      speedSetting = panelEl.first().height() / speedSetting;
      marqueeTimeline.fromTo(panelEl, { yPercent: 0 }, { yPercent: moveDistanceSetting, ease: "none", duration: speedSetting });
    } else {
      speedSetting = panelEl.first().width() / speedSetting;
      marqueeTimeline.fromTo(panelEl, { xPercent: 0 }, { xPercent: moveDistanceSetting, ease: "none", duration: speedSetting });
    }
    let scrubObject = { value: 1 };
    ScrollTrigger.create({
      trigger: "body",
      start: "top top",
      end: "bottom bottom",
      onUpdate: (self) => {
        if (!pausedStateSetting) {
          if (scrollDirectionSetting && timeScaleSetting !== self.direction) {
            timeScaleSetting = self.direction;
            marqueeTimeline.timeScale(self.direction);
          }
          if (scrollScrubSetting) {
            let v = self.getVelocity() * 0.006;
            v = gsap.utils.clamp(-60, 60, v);
            let scrubTimeline = gsap.timeline({ onUpdate: () => marqueeTimeline.timeScale(scrubObject.value) });
            scrubTimeline.fromTo(scrubObject, { value: v }, { value: timeScaleSetting, duration: 0.5 });
          }
        }
      }
    });
    function pauseMarquee(isPausing) {
      pausedStateSetting = isPausing;
      let pauseObject = { value: 1 };
      let pauseTimeline = gsap.timeline({ onUpdate: () => marqueeTimeline.timeScale(pauseObject.value) });
      if (isPausing) {
        pauseTimeline.fromTo(pauseObject, { value: timeScaleSetting }, { value: 0, duration: 0.5 });
        triggerClickEl.addClass("is-paused");
      } else {
        pauseTimeline.fromTo(pauseObject, { value: 0 }, { value: timeScaleSetting, duration: 0.5 });
        triggerClickEl.removeClass("is-paused");
      }
    }
    if (window.matchMedia("(pointer: fine)").matches) {
      triggerHoverEl.on("mouseenter", () => pauseMarquee(true));
      triggerHoverEl.on("mouseleave", () => pauseMarquee(false));
    }
    triggerClickEl.on("click", function () {
      !$(this).hasClass("is-paused") ? pauseMarquee(true) : pauseMarquee(false);
    });
  });
});
  } catch (e) {
    console.warn('prototype.js block 9:', e && e.message);
  }
})();

/* ---- block 10 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll("[data-css-scroll]");
  if (!targets.length) return;
  const thresholdGroups = new Map();
  targets.forEach(el => {
    const thresholdStr = el.dataset.cssScrollThreshold || "5%";
    const threshold = parseFloat(thresholdStr) / 100;
    if (!thresholdGroups.has(threshold)) thresholdGroups.set(threshold, []);
    thresholdGroups.get(threshold).push(el);
  });
  const entryObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting && !entry.target.__pastThreshold && entry.target.__ioInit) {
        entry.target.classList.add("animation-ready");
        entryObserver.unobserve(entry.target);
      }
    }
  }, { threshold: 0, rootMargin: "-1px" });
  const exitObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const el = entry.target;
      const mode = el.dataset.cssScroll || "";
      if (!entry.isIntersecting && mode !== "retrigger-none" && el.__ioInit) {
        const isExitingTop = entry.boundingClientRect.bottom < entry.rootBounds.top;
        if (mode === "retrigger-both" || !isExitingTop) el.classList.add("animation-ready");
      }
    }
  }, { threshold: 0, rootMargin: "-1px" });
  thresholdGroups.forEach((elements, threshold) => {
    const io = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const el = entry.target;
        const mode = el.dataset.cssScroll || "";
        if (!el.__ioInit) {
          el.__ioInit = true;
          if (entry.isIntersecting) el.__cssAnimTriggered = el.__pastThreshold = true;
          continue;
        }
        if (!entry.isIntersecting) {
          if (mode !== "retrigger-none") el.__cssAnimTriggered = false;
          continue;
        }
        const isScrollingDown = entry.boundingClientRect.top >= 0 && entry.boundingClientRect.top < entry.rootBounds.bottom;
        const shouldTrigger = mode === "retrigger-none" ? !el.__cssAnimTriggered : mode === "retrigger-both" ? !el.__cssAnimTriggered : !el.__cssAnimTriggered && isScrollingDown;
        if (!shouldTrigger) continue;
        el.__cssAnimTriggered = true;
        if (!el.classList.contains("animation-ready")) continue;
        el.classList.remove("animation-ready");
        el.classList.add("reset-animations");
        el.offsetHeight;
        requestAnimationFrame(() => {
          el.classList.remove("reset-animations");
          if (mode === "retrigger-none") io.unobserve(el);
        });
      }
    }, { threshold });
    elements.forEach(el => {
      io.observe(el);
      entryObserver.observe(el);
      exitObserver.observe(el);
    });
  });
});
  } catch (e) {
    console.warn('prototype.js block 10:', e && e.message);
  }
})();

/* ---- block 11 ---- */
(function () {
  try {
document.addEventListener('DOMContentLoaded', function() {
  function initSwiper(product) {
    const $p = $(product);
    const swiper = new Swiper($p.find(".swiper")[0], {
      speed: 300,
      loop: false,
      autoHeight: false,
      followFinger: true,
      freeMode: false,
      slideToClickedSlide: false,
      slidesPerView: "auto",
      spaceBetween: 60,
      rewind: false,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      mousewheel: { forceToAxis: true },
      keyboard: { enabled: true, onlyInViewport: true },
      pagination: {
        el: $p.find(".swiper-bullet-wrapper")[0],
        bulletActiveClass: "is-active",
        bulletClass: "swiper-bullet",
        bulletElement: "button",
        clickable: true
      },
      navigation: {
        nextEl: $p.find(".swiper-next")[0],
        prevEl: $p.find(".swiper-prev")[0],
        disabledClass: "is-disabled"
      },
      scrollbar: {
        el: $p.find(".swiper-drag-wrapper")[0],
        draggable: true,
        dragClass: "swiper-drag",
        snapOnRelease: true
      },
      slideActiveClass: "is-active",
      slideDuplicateActiveClass: "is-active"
    });

    setTimeout(function() { swiper.update(); }, 300);
  }

  $(".rewards_wrap .rewards_initiator").each(function() {
    initSwiper(this);
  });
});
  } catch (e) {
    console.warn('prototype.js block 11:', e && e.message);
  }
})();

/* ---- block 12 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product_wrap").forEach((element) => {
    if (element.dataset.scriptInitialized) return;
    element.dataset.scriptInitialized = "true";
    
    // Find the elements based on the correct structure
    let productWrap = $(element);
    let mainSliderComponent = productWrap.find(".product_main_component");
    let thumbnailItems = productWrap.find(".product_thumbnail_item");
    
    // Find navigation elements in their correct locations
    let mainNextButton = productWrap.find(".product_slider_btn_wrap .swiper-next");
    let mainPrevButton = productWrap.find(".product_slider_btn_wrap .swiper-prev");
    
    // Other Swiper elements
    let mainPaginationElement = mainSliderComponent.siblings(".swiper-pagination");
    let mainDragWrapper = mainSliderComponent.find(".swiper-drag-wrapper");
    
    // Only proceed if we have both the main slider and thumbnails
    if (mainSliderComponent.length > 0 && thumbnailItems.length > 0) {
      let mainLoopMode = mainSliderComponent.attr("loop-mode") === "true";
      let mainSliderDuration = 300;
      if (mainSliderComponent.attr("slider-duration") !== undefined) {
        mainSliderDuration = +mainSliderComponent.attr("slider-duration");
      }
      
      
      // Initialize the main slider
      const mainSwiper = new Swiper(mainSliderComponent.find(".swiper")[0], {
        speed: mainSliderDuration,
        loop: mainLoopMode,
        autoHeight: false,
        spaceBetween: 40,
        slidesPerView: "auto",
        navigation: {
          nextEl: mainNextButton[0],
          prevEl: mainPrevButton[0],
          disabledClass: "is-disabled"
        },
        pagination: {
          el: mainPaginationElement[0],
          clickable: true
        },
        scrollbar: {
          el: mainDragWrapper[0],
          draggable: true,
          dragClass: "swiper-drag",
          snapOnRelease: true
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        slideActiveClass: "is-active",
        slideDuplicateActiveClass: "is-active"
      });
      
      // Add is-active class to first thumbnail by default
      $(thumbnailItems[0]).addClass("is-active");
      
      // Add click event handlers to each thumbnail item
      thumbnailItems.on("click", function() {
        const index = $(this).index();
        
        // Navigate main slider to this index
        mainSwiper.slideTo(index);
        
        // Update active class on thumbnails
        thumbnailItems.removeClass("is-active");
        $(this).addClass("is-active");
      });
      
      // Update thumbnails when main slider changes
      mainSwiper.on("slideChange", function() {
        const activeIndex = mainSwiper.activeIndex;
        const realIndex = mainSwiper.realIndex; // Use realIndex when in loop mode
        
        // Use the appropriate index depending on loop mode
        const currentIndex = mainLoopMode ? realIndex : activeIndex;
        
        // Update active class on thumbnails
        thumbnailItems.removeClass("is-active");
        $(thumbnailItems[currentIndex]).addClass("is-active");
      });
    }
  });
});
  } catch (e) {
    console.warn('prototype.js block 12:', e && e.message);
  }
})();

/* ---- block 13 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", function () {
  // Global approach - tries to find elements anywhere in document
  document.querySelectorAll(".nutritional_close_wrap, .nutritional_overlay").forEach((closeElem) => {
    closeElem.addEventListener("click", function() {
      document.querySelector(".product_nutritional_txt_wrap")?.click();
    });
  });
});
  } catch (e) {
    console.warn('prototype.js block 13:', e && e.message);
  }
})();

/* ---- block 14 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", function() {
  function updateStarFills() {
    const ratingElement = document.querySelector('.reviews_average_rating');
    if (!ratingElement) return;
    
    const rating = parseFloat(ratingElement.textContent.trim());
    if (isNaN(rating)) return;
    
    document.querySelectorAll('.product_rating_span.is-average').forEach(function(span) {
      span.textContent = rating % 1 === 0 ? rating.toString() : rating.toFixed(1);
    });
    
    const totalReviewsElement = document.querySelector('.reviews_total_reviews');
    if (totalReviewsElement) {
      document.querySelectorAll('.product_rating_span.is-total').forEach(function(span) {
        span.textContent = totalReviewsElement.textContent.trim();
      });
    }
    
    document.querySelectorAll('.product_rating_wrap').forEach(function(ratingWrap) {
      const stars = ratingWrap.querySelectorAll('.product_rating_star');
      
      stars.forEach(function(star, index) {
        const starNumber = index + 1;
        const fillPath = star.querySelector('.product_rating_fill');
        if (!fillPath) return;
        
        if (rating >= starNumber) {
          fillPath.style.clipPath = 'inset(0 0 0 0)';
        } else if (rating > starNumber - 1) {
          const fillPercentage = (rating - (starNumber - 1)) * 100;
          fillPath.style.clipPath = `inset(0 ${100 - fillPercentage}% 0 0)`;
        } else {
          fillPath.style.clipPath = 'inset(0 100% 0 0)';
        }
        
        fillPath.style.transition = 'opacity 0.3s ease';
        fillPath.style.transitionDelay = (index * 0.08) + 's';
        fillPath.style.opacity = '1';
      });
    });
  }
  
  updateStarFills();
  
  const observer = new MutationObserver(function() {
    setTimeout(updateStarFills, 100);
  });
  
  const ratingElement = document.querySelector('.reviews_average_rating');
  if (ratingElement) {
    observer.observe(ratingElement, { 
      childList: true, 
      characterData: true, 
      subtree: true 
    });
  }
  
  const reviewsSection = document.querySelector('.reviews_wrap');
  if (reviewsSection) {
    observer.observe(reviewsSection, { 
      childList: true, 
      subtree: true 
    });
  }
});
  } catch (e) {
    console.warn('prototype.js block 14:', e && e.message);
  }
})();

/* ---- block 15 ---- */
(function () {
  try {
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const labels = document.querySelectorAll('.star-radio-buttons-2 .radio-button-field');
    
    labels.forEach((label) => {
      const input = label.querySelector('input[type="radio"]');
      const starButton = label.querySelector('.star-radio-button');
      
      if (input && starButton) {
        input.addEventListener('focus', function() {
          const clickHandler = () => {
            starButton.click();
          };
          
          input._keyHandler = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              clickHandler();
            }
          };
          
          window.addEventListener('keydown', input._keyHandler);
        });
        
        input.addEventListener('blur', function() {
          if (input._keyHandler) {
            window.removeEventListener('keydown', input._keyHandler);
          }
        });
      }
    });
  }, 1500);
});
  } catch (e) {
    console.warn('prototype.js block 15:', e && e.message);
  }
})();

/* ---- block 16 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", (event) => {
  // SplitText on a selector that is not on the page returns empty word arrays,
  // and gsap.set() on those throws inside the ticker, which freezes every
  // animation queued after it in the global timeline: the perks marquee
  // included. Guard per selector so a missing intro is a no-op.
  function blurWordsIn(selector) {
    if (!document.querySelector(selector)) return;
    const split = new SplitText(selector, { type: "words, chars" });
    if (!split.words || !split.words.length) return;
    gsap.set(split.words, { filter: "blur(20px)" });
    gsap.to(split.words, {
      filter: "blur(0px)",
      stagger: 0.05,
      duration: 0.8,
      scrollTrigger: {
        trigger: selector,
        start: "top 90%"
      }
    });
  }

  blurWordsIn(".intro_subtxt_txt");
  blurWordsIn(".intro_main_subtxt_txt");
});
  } catch (e) {
    console.warn('prototype.js block 16:', e && e.message);
  }
})();

/* ---- block 17 ---- */
(function () {
  try {
document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(SplitText)
 });
  } catch (e) {
    console.warn('prototype.js block 17:', e && e.message);
  }
})();
